// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","purchaseModal":"Modal_purchaseModal__-xDCH","messageModal":"Modal_messageModal__1z6aK"};